export const TaggingService = Symbol.for('TaggingService');
